<template>
  <div id="consulta" class="d-flex flex-row flex-wrap justify-content-center">
    <Header :logged="logged" :totem="totem" />

    <b-modal ref="modalPDF" size="xl" scrollable title="Visualização de PDF" id="modal-dialog" class="modal-fullscreen" hide-footer>
      <div class="pdf-container">
        <object width="100%" height="100%" type="application/pdf" :data="pdfUrl"></object>
      </div>
    </b-modal>

    <div id="wrapper-spinner" v-if="loading"
      style="display: block;position: absolute;background: #aaa0a08f;z-index: 100;width: 100%;height: 100%;padding-top: 25%;padding-left: 50%;">
      <BeatLoader color="var(--main-azul)" />
    </div>

    <div id="consulta-form" class="w-100">
      <div class="card text-center card-form">
        <div class="card-body">
          <h3 class="text-center mb-5"><b>Consulta de PDF</b></h3>
          <div class="form-group">
            <label id="label-chave" for="input-chave" class="w-100 text-center">Digite a Chave</label>
            <span v-b-popover.hover.top="'Digite atentamente sua chave!.'" title="Chave">
              <b-form-input id="input-chave" class="mb-4" size="lg" v-model="chave" placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" trim></b-form-input>
            </span>
          </div>
          <div class="form-group">
            <label id="label-anuencia" for="input-anuencia" class="w-100 text-center">Digite o Número da Anuência</label>
            <span v-b-popover.hover.top="'Digite atentamente o número da anuência!.'" title="Número da Anuência">
              <b-form-input id="input-anuencia" class="mb-4" size="lg" v-model="anuencia" placeholder="Número da Anuência" trim></b-form-input>
            </span>
          </div>
          <b-row>
            <b-col sm="6" class="mb-2">
              <b-button class="btn-gerar-pdf" @click="consultarPDF()">
                <font-awesome-icon size="2x" icon="file-pdf" />
                <span>Consultar PDF</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" size="invisible" :sitekey="sitekey"></vue-recaptcha>
    <footersite class="d-none d-xl-block" v-if="!totem" />
    <footersitemobile class="d-block d-xl-none" v-if="!totem" />
  </div>
</template>

<script>
import API from "../services/api";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";
import Header from '../components/Header';
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";

export default {
  props: ['totem'],
  components: {
    BeatLoader,
    VueRecaptcha,
    Header,
    footersite,
    footersitemobile,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
      logged: false,
      chave: "", // Inicialmente vazio
      anuencia: "", // Inicialmente vazio
      tok: "", // Inicialmente vazio
      loading: false,
      pdfUrl: ""
    };
  },
  mounted() {
    this.$root.isLogged().then(() => {
      this.logged = true;
      this.getParamsFromRoute();
    }).catch(() => {
      this.logged = false;
      this.getParamsFromRoute();
    });
  },
  methods: {
    getParamsFromRoute() {
      this.chave = this.$route.params.nm_chave || "";
      this.anuencia = this.$route.params.cd_download_generico || "";
      this.tok = this.$route.query.tok || "";

      if (this.chave && this.anuencia) {
        this.consultarPDF();
      }
    },
    onVerify: function (response) {
      this.tok = response;
      this.$refs.invisibleRecaptcha.reset();
      if (this.chave) {
        this.consultarPDF();
      }
    },
    onExpired: function () {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    consultarPDF() {
      if (!this.chave || !this.anuencia) {
        alert('Por favor, forneça a chave, o token e o número da anuência.');
        return;
      }
      
      this.loading = true;
      API.get(`/download-generico/${this.chave}/${this.anuencia}`, { responseType: 'blob' })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          this.pdfUrl = url;
          this.loading = false;
          this.$refs["modalPDF"].show();
        })
        .catch(err => {
          alert('PDF não encontrado! Verifique sua chave.');
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
#rodape {
  background-color: #185684;
  width: 100%;
  height: 145px;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
}

html {
  overflow: hidden !important;
}

#logo-header {
  width: 300px;
}

.icone {
  font-size: 16px;
  margin-top: 10px;
}

#consulta-form {
  margin-top: 120px;
  background: #fbfbfd;
  height: calc(100vh - 120px - 37px) !important;
  padding: 0px 17px;
  align-items: center;
  display: flex;
}

#consulta-form .card-form {
  max-width: 850px;
  min-width: 500px;
  margin: 0 auto;
  padding: 40px;
  box-shadow: 17px 20px 40px rgba(0, 0, 0, .21);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  border-radius: 16px;
  border: none;
}

h3 {
  font: normal normal bold 30px/30px 'Kanit', sans-serif;
  letter-spacing: -2.8px;
  text-rendering: optimizeLegibility;
}

h4 {
  font: normal normal normal 22px/25px 'Kanit', sans-serif;
  letter-spacing: 0;
  text-rendering: optimizeLegibility;
  max-width: 300px;
}

#label-infolet {
  position: static;
  font-size: 12px;
  line-height: 1.33337;
  font-weight: 400;
  letter-spacing: -.01em;
  color: #6e6e73 !important;
  margin-bottom: 0.5rem;
}

input {
  background-color: hsla(0, 0%, 100%, .8);
  height: 58px;
  border-color: #86868b;
  font-size: 17px;
  line-height: 1.23536;
  font-weight: 400;
  letter-spacing: -.022em;
  width: 100%;
  height: 3.29412rem;
  border-radius: 12px;
  box-sizing: border-box;
  color: #494949;
  border: 1px solid;
  border-radius: 12px;
  margin-bottom: .82353rem;
  padding: 1.05882rem .94118rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 700px;
}

button {
  display: flex;
  align-items: center;
  width: fit-content;
  height: 52px;
  border-radius: 5px;
  letter-spacing: -.022;
  opacity: 1;
  font: normal normal bold 17px/18px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #ffffff;
  border: none;
  min-width: 213px;
  justify-content: space-between;
  width: 100%;
}

button svg {
  font-size: 25px;
}

button img {
  height: 30px;
}

button span {
  text-align: center;
  width: 100%;
}

button.btn-gerar-pdf {
  background: #B30B00 0% 0% no-repeat padding-box;
  float: left;
}

button.btn-gerar-pdf:active,
button.btn-gerar-pdf:hover {
  background: #6b0902 0% 0% no-repeat padding-box;
}

button.btn-exportar-busca {
  background: #1ACEB5 0% 0% no-repeat padding-box;
  float: right;
}

button.btn-exportar-busca:active,
button.btn-exportar-busca:hover {
  background: #00733b 0% 0% no-repeat padding-box;
}

@media (max-width: 1199px) {
  #consulta-form {
    margin-top: 68px;
    height: fit-content;
  }
}

@media (max-width: 525px) {
  #consulta-form .card-form {
    padding: 40px 20px;
  }

  #consulta-form .card-form .card-body {
    padding: 0px;
  }
}

/* New Styles */
.modal-fullscreen .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100vh;
}

.pdf-container {
  height: calc(100vh - 56px); /* Adjust height for the modal header */
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
